module.exports = __webpack_public_path__ + "img/google-analytics.cc521ae4.svg";